<template>
  <div class="overall-bg pt-0">
    <b-container>
      <b-row class="stepperdiv">
        <b-col lg="6" md="6" sm="6" cols="2">
          <BackBtn :goback="$router.back" />

          <Headerlayout v-if="paramValue == 'salesorderissue'" :headertext="$t('SalsedOrderIssue.title')"
            :contenttext="$t('SalsedOrderIssue.contents')"></Headerlayout>

        </b-col>
        <b-col lg="6" md="6" sm="6" cols="2" v-if="items.length != 0 && !afterSave">
          <Footer class="pb-3" @save="SubmitFunc()" :goback="$router.back" :label="label" :loading="SaveLoading" />
        </b-col>
      </b-row>
      <b-row class="form-white-bg">
        <div>
          <b-row>
            <b-col lg="10" md="10" sm="6" cols="12">
              <Issue :showone="paramValue" v-model="remarks" :storeDetails="requestForm" />
            </b-col>
            <b-col lg="2" md="2" sm="6" cols="12" class="d-flex" v-if="!afterSave">
              <div class="field">
                <label>{{ $t("Request.uploadquotation") }}</label>
                <input type="file" :multiple="true" id="actual-btn" @change="handleChangedocument" ref="fileInput"
                  style="display: none" />
                <label id="custom-btn" for="actual-btn" class="flbtn">
                  <i class="pi pi-upload" style="color: slateblue"></i>
                  Choose File</label>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                    view
                  </div>
                </div>
                <DeleteIcon @click="fileuploadDelete(item)" />
              </div>
            </b-col>
          </b-row>

          <b-col class="d-flex flex-row-reverse" v-if="afterSave">
            <div class="colourCodeStatusBg">
              <div class="confirmationtime" v-for="i1 in colourCodeList">
                <div class="d-flex align-items-center gap-2">
                  <div class="confirmedicon" :style="{ backgroundColor: i1.OrderColor }"></div>
                  <p>{{ i1.StatusName }}</p>
                </div>
              </div>
            </div>
          </b-col>
          <b-row>
            <b-col lg="2" md="2" sm="6" cols="12" class="my-3">
              <Datepicker class="date" label="From Date" name="" id="" v-model="FromDate"
                @date-select="LoadGRNDocNo(FromDate, ToDate)" />
            </b-col>
            <b-col lg="2" md="2" sm="6" cols="12" class="my-3">
              <Datepicker class="date" label="To Date" name="" id="" v-model="ToDate"
                @date-select="LoadGRNDocNo(FromDate, ToDate)" />
            </b-col>
            <b-col lg="2" md="2" sm="6" cols="12" class="my-3">

              <CustomDropdown :required-icon="true" placeholder="Select GRN No" :label="$t('issue.grnno')"
                v-model="DocNo" :rules="{ required: false }" name="GRN No" id="GRN No" :items="DocNoOpiton"
                :showClear="true" @change="GRNDocNoOnChange" :disabled="StoreDetails.grnnodisabled" />
            </b-col>
            <b-col lg="3" md="3" sm="6" cols="12" class="my-3">
              <CustomDropdown :required-icon="true" placeholder="Select store" :label="$t('issue.tostore')"
                v-model="StoreDetails.ToStoreBranchMapId" :rules="{ required: false }" name="store" id="store"
                :items="StoreDetails.ToStoreOpiton" :showClear="false" @change="ToStoreOnChange"
                :disabled="StoreDetails.ToStoreDisable" />
            </b-col>

            <b-col lg="1" md="1" sm="6" cols="12" class="my-3">
              <Button class="p-button-secondary p-button-sm cancelbtn ms-2 mt-4" @click="ClearOnClick">
                Clear
              </Button>
            </b-col>

            <b-col lg="2" md="2" sm="6" cols="12" class="my-3">
              <p class="add-items mt-4" v-b-toggle.collapse-3>
                + Add Items
              </p>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <!-- <b-collapse id="collapse-3" visible :class="displayClass"> -->
              <b-collapse id="collapse-3" :class="displayClass">
                <Items @additemclick="AddItems" :show-fields="showFields" v-model:data-items="dataItems"
                  :addItemData="items" :isFilterData="itemDatas" :commonItemProps="commonItemProps" />
              </b-collapse>
            </b-col>
          </b-row>

        </div>

        <!-- {{ items }} -->
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <Table v-model:value="items" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id"
            :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll" :columns="headers"
            :seriaNlumber="true" @updatedata="Itemschanges"
            :addnewbtn="$route.query.param == 'IndirectIssue' ? true : false">

            <template v-slot:UOMSlot="{ data }">
              <span v-if="data.Editable">
                <CustomDropdown :items="data.UOMoption" v-model="data.UOM" :showClear="false" @update:modelValue="">
                </CustomDropdown>
              </span>
              <span v-else @click="ShowUOMDropdown(data)">{{
                data.UOMName
              }}</span>
            </template>

            <template v-slot:Itemname1="{ data }">
              <span>
                {{ data.Itemname1 }}
              </span>
              <span class="spantxt">
                {{ data.BarCode }}
              </span>
            </template>

            <template v-slot:RequestedQuantity="{ data }">
              {{ data.RequestedQty }}
            </template>

            <template v-slot:ItemQuantity="{ data, rowIndex }">
              <div class="label-d-none tablefield mb-0">
                <InputText type="text" placeholder="" @keyup="ItemQtyOnChange(data)" clearable
                  :name="`'ItemQuantity'${data.index}`" :id="`'ItemQuantity'${data.index}`" label=""
                  v-model="data.ItemQuantity" :rules="{ required: false, numeric: true }" :requiredIcon="false"
                  :disabled="data.DeleteFlag || afterSave || data.ToStoreCategoryItem == 0
                    " />
              </div>
            </template>

            <template v-slot:ExpiryDate="{ data }">
              <div>
                <span :style="getExpiryDateStyle(data.ExpiryDate)">
                  {{
                    data.ExpiryDate == "01-01-0001" || data.ExpiryDate == "01-01-1900"
                      ? ""
                      : data.ExpiryDate
                  }}
                </span>
                <div v-if="getExpiryMessage(data.ExpiryDate)" class="expiry-message">
                  {{ getExpiryMessage(data.ExpiryDate) }}
                </div>
              </div>
            </template>

            <template v-slot:StockInHandSlot="{ data }">
              {{ data.StockInHand }}
            </template>
            <template v-slot:ItemCategorySlot="{ data }">
              <p>
                {{ data.ItemCategory1 }}
              </p>
              <p v-if="data.ToStoreCategoryItem == 0" class="text-center" style="color: red">
                (Category Not Mapped)
              </p>
            </template>
            <template v-slot:ModelNumberNameSlot="{ data }">
              <p v-if="
                data.BrandName == null &&
                data.ModelNumberName == null &&
                data.SizeName == null
              ">
                <span>
                  {{ "-" }}
                </span>
              </p>
              <p v-else>
                <span>
                  {{ data.BrandName != null ? data.BrandName : "-" }} /
                  {{ data.ModelNumberName != null ? data.ModelNumberName : "-" }}
                  /
                  {{ data.SizeName != null ? data.SizeName : "-" }}
                </span>
              </p>
            </template>

            <template v-slot:MRPSlot="{ data, rowIndex }">
              <div class="label-d-none tablefield mb-0">
                <TextField placeholder="" clearable
                  :name="`'MRP'${data.ItemId}${data.MRP}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                  :id="`'MRP'${data.ItemId}${data.MRP}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                  label="" v-model="data.MRP" :rules="{ decimal: false, nonzeroable: true }" :disabled="false" />
              </div>
            </template>

            <template v-slot:UnitRateSlot="{ data, rowIndex }">
              <div class="label-d-none tablefield mb-0">
                <TextField placeholder="" clearable
                  :name="`UnitRate${data.ItemId}${data.UnitRate}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                  :id="`UnitRate${data.ItemId}${data.UnitRate}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}`"
                  @keyup="ItemUnitRateOnChange(data)" label="" v-model="data.UnitRate"
                  :rules="{ decimal: true, nonzeroable: true }" :disabled="false" />
              </div>
            </template>

            <template v-slot:FreeQty="{ data, rowIndex }">
              <div class="label-d-none tablefield mb-0">
                <TextField placeholder="" clearable
                  :name="`'FreeQty'${data.ItemId}${data.FreeQty}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}${data.IsFreeItem}${data.IsFreeQtyItem}`"
                  :id="`'FreeQty'${data.ItemId}${data.FreeQty}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.BatchNo}${data.IsFreeItem}${data.IsFreeQtyItem}`"
                  label="" v-model="data.FreeQty" :rules="{ numeric: true }" :disabled="false" />
              </div>
            </template>


            <template v-slot:Discount="{ data, }">
              <div class="label-d-none tablefield mb-0">
                <TextField placeholder="" clearable
                  :name="`'Discount'${data.ItemId}${data.BatchNo}${data.Discount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                  :id="`'Discount'${data.ItemId}${data.BatchNo}${data.Discount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                  @keyup="ItemDiscountAmountCalculation(data)" label="" v-model="data.Discount"
                  :rules="{ required: false, decimal: true, percentage: true }" :requiredIcon="false"
                  :disabled="false" />
              </div>
            </template>
            <template v-slot:DiscountAmount="{ data, rowIndex }">

              <div class="label-d-none tablefield mb-0">
                <TextField placeholder="" clearable
                  :name="`'DiscountAmount'${data.ItemId}${data.BatchNo}${data.Discountamount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                  :id="`'DiscountAmount'${data.ItemId}${data.BatchNo}${data.Discountamount}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}${data.rowIndex}`"
                  @keyup="ItemDiscountPercentageCalculation(data)" label="" v-model="data.Discountamount"
                  :rules="{ required: false, decimal: true }" :requiredIcon="false" :disabled="false" />
              </div>

            </template>
            <template v-slot:servicecharges="{ data, rowIndex }">

              <div class="label-d-none tablefield mb-0">
                <TextField placeholder="" clearable
                  :name="`'servicecharges'${data.ItemId}${data.BatchNo}${data.servicecharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                  :id="`'servicecharges'${data.ItemId}${data.BatchNo}${data.servicecharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                  @keyup="
                    ItemServiceChargesOnChange(data)
                    " label="" v-model="data.servicecharges" :rules="{ required: false, decimal: true }"
                  :requiredIcon="false" :disabled="false" />
              </div>
            </template>
            <template v-slot:othercharges="{ data, rowIndex }">

              <div class="label-d-none tablefield mb-0">
                <TextField type="text" placeholder="" clearable
                  :name="`'othercharges'${data.ItemId}${data.BatchNo}${data.othercharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                  :id="`'othercharges'${data.ItemId}${data.BatchNo}${data.othercharges}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                  @keyup="
                    ItemOtherChargesOnChange(data)
                    " label="" v-model="data.othercharges" :rules="{ required: false, decimal: true }"
                  :requiredIcon="false" :disabled="false" />
              </div>
            </template>

            <template v-slot:SupplierBarCode="{ data, rowIndex }">
              <div class="label-d-none tablefield mb-0">
                <TextField type="text" placeholder="" clearable
                  :name="`'SupplierBarCode'${data.ItemId}${data.SupplierBarCode}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                  :id="`'SupplierBarCode'${data.ItemId}${data.SupplierBarCode}${data.Brand}${data.ModelNumber}${data.Size}${data.Id}${data.ToStore}`"
                  label="" v-model="data.SupplierBarCode" :rules="{ required: false }" :requiredIcon="false"
                  :disabled="false" />
              </div>
            </template>

            <template v-slot:action="{ data }">
              <span v-if="!data.DeleteFlag && !afterSave">
                <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                  @click="toggle($event, data)" />
              </span>
            </template>
          </Table>
        </div>
      </b-row>

      <b-row class="form-white-bg pt-0">
        <b-col>
          <div class="field">
            <!-- {{requestForm.GRNTransportationCharges}} -->
            <TextField name="Transportation Charges" :label="$t('grn.transportationcharges')"
              :rules="{ required: false, decimal: true }" id="Transportation Charges"
              v-model="createrequestForm.GRNTransportationCharges" @keyup="TransportAmountOnChange" :disabled="false" />
          </div>

        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Transportation Tax" :label="$t('grn.transportationtax')"
              :rules="{ required: false, decimal: true, percentage: true }" id="Transportation Tax"
              v-model="createrequestForm.GRNTransportationTax" @keyup="TransportTaxOnChange" :disabled="false" />
          </div>
        </b-col>

        <b-col>
          <div class="field">
            <TextField name="Freight Charges" :label="$t('grn.freightcharges')"
              :rules="{ required: false, decimal: true }" id="Freight Charges"
              v-model="createrequestForm.GRNFreightCharges" @keyup="FreightAmountOnChange" :disabled="false" />
          </div>
        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Freight Tax" :label="$t('grn.freighttax')"
              :rules="{ required: false, decimal: true, percentage: true }" id="Transportation Tax"
              v-model="createrequestForm.GRNFreightTax" @keyup="FreightTaxOnChange" :disabled="false" />
          </div>
        </b-col>

        <b-col>
          <div class="field">
            <TextField name="Other Charges" :label="$t('grn.othercharges')" :rules="{ required: false, decimal: true }"
              id="Other Charges" v-model="createrequestForm.GRNOtherCharges" @keyup="OverallOtherChargesOnChange"
              :disabled="false" />
          </div>
        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Discount" :label="$t('grn.discountamount')" :rules="{ required: false, decimal: true }"
              id="Discount" v-model="createrequestForm.GRNDiscount" @keyup="OverAllDiscountAmountOnChange"
              :disabled="false" />
          </div>
        </b-col>
        <b-col>
          <div class="field">
            <TextField name="Roundoff" :label="$t('grn.roundoff')" v-model="createrequestForm.RoundOff"
              :rules="{ required: false, alphabet: false }" id="Roundoff" @keyup="RoundOffOnChange" :disabled="false" />
          </div>
        </b-col>
      </b-row>

      <b-row class="form-white-bg pt-0">
        <b-col lg="12" md="12" sm="12" cols="12">
          <b-row class="mt-1">
            <b-col lg="8" md="8">
            </b-col>
            <b-col lg="4" md="4">
              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Gross Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.grossamount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Discount Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.totaldiscountamount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Tax Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.taxamount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    SGST Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.sgsttaxamount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    CGST Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.cgsttaxamount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    IGST Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.igsttaxamount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Transport charges
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.transportcharges }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Freight charges
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.freightcharges }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Service Charges
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.servicecharges }}
                  </p>
                </b-col>
              </b-row>


              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Other charges
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ grossvalues.othercharges }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="d-flex align-items-center mt-5">
                  <p>
                    Grand Total
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col offset-lg="3" class="d-flex px-0">
                  <div class="totaldiv1">
                    <p class="component-heading">{{ grossvalues.totalqty }}</p>

                    <p class="light-txt">Items Part of this GRN</p>
                  </div>
                  <div class="totaldiv2">
                    <p class="component-heading"><span class="pe-1">&#8377</span>{{
                      grossvalues.netamount }}
                    </p>
                    <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                  </div>
                </b-col>
              </b-row>

            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-container>
  </div>

  <Toast />
  <Menu ref="menu" id="overlay_menu" :model="itemList" :popup="true" />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsItemEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <EditConfirmation :Editmodel="modelQty" @yes="IsSubmit" @no="modelQty = false"
    content="Item List has 0 Quantity.Do you want proceed without adding that item?" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsItemDelete(dataEdit)" @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="deleteclosetrigger()" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />
  <AlreadyExist :selectedcontent="selectedcontent" :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />

  <Dialog v-model:visible="StoreSupplierVaidationpopup" header="Info" :closable="false" :style="{ width: '25rem' }">
    <div class="storesupplierpopupbg">
      <p>Store Supplier not found for the selected store.
        <span>
          Kindly select a store with supplier or map the supplier to the store.
        </span>
      </p>
    </div>
  </Dialog>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  computed,
  onMounted,
  watch,
} from "vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import BackBtn from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import Table from "../../../../../../../components/FormComponents/NormalTable.vue";
import PurchaseOrder from "../../../../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue";
import IssuePopup from "../../../../../../../modules/Inventory/components/Transaction/stockout/IssuePopup.vue";
import Issue from "../../../../../../../modules/Inventory/components/Transaction/stockout/IssueComponent.vue";
import Items from "../../../../../../../modules/Inventory/components/Transaction/Item.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import { useRoute, useRouter } from "vue-router";
import Service from "../../../../../../../modules/Inventory/Service/StockOutService";
import WithoutStockService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import common from "../../../../../../../modules/Inventory/Service/CommonService";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import commonservice from "../../../../../../../modules/Inventory/Service/StoreService";
import StockWODetailsService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import commonService from "../../../../../../../modules/Inventory/Service/StockInService";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import Datepicker from "../../../../../../../components/FormComponents/DatePicker.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import UnitMasterService from "../../../../../../../modules/Inventory/Service/UnitMasService";
import commonServiceWO from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useI18n } from "vue-i18n";
import { setupHistoryManagement } from "../../../../../../../modules/Inventory/Service/HistoryManage";
import StockInFileUploadServices from "../../../../../../../modules/Inventory/Service/StockInFileUploadService";
import StockWOFileUploadServices from "../../../../../../../modules/Inventory/Service/StockWOFileUploadService";
import Itemservice from "../../../../../../../modules/Inventory/Service/ItemMasService";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import AutoComplete from "../../../../../../../components/FormComponents/AutoComplete.vue";
import CustomMultiSelect from "../../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import SupplierMasterService from "../../../../../../../modules/Inventory/Service/SupplierMaster";
import StoreDetails from "../../../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreDetails.vue";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";

export default defineComponent({
  components: {
    MasterEmpty,
    TextField,
    Datepicker,
    BackBtn,
    Headerlayout,
    Table,
    Items,
    Footer,
    PurchaseOrder,
    IssuePopup,
    Issue,
    CreateSuccessully,
    UpdatedSuccessfully,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    Loader,
    CrystalReportPrintPopUp,
    CustomDropdown,
    AlreadyExist,
    AutoComplete,
    CustomMultiSelect,
    Tableview,
    SkeletonTableLoader
  },

  setup(props, { emit }) {
    debugger;
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = session.BranchId;
    let UserId = Number(session.UserId);
    let Admin = Number(session.Admin);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    let selectedcontent = ref("Some Items has no stock");
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    const toast = useToast();
    const router = useRouter();
    const route = useRoute();
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const modelQty = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const dataEdit = ref();
    const itemDatas = ref([]);
    let DocNo = ref("");
    let FromDate = ref("");
    let ToDate = ref("");
    let OperationId = ref(0);
    let Entitydata = ref();
    const alreadyexistpop = ref(false);

    const display = ref(true);
    const displayClass = ref("");
    const dataItems = ref({});
    const CrystalReportPopup = ref(false);
    let afterSave = ref(false);
    let items: any = ref([]);
    let checkitem: any = ref([]);


    let loading = ref(false);
    let SaveLoading = ref(false);

    let List = ref([]);
    var arr: any = [];
    var checkstockAvailabilityresultarr: any = [];
    var Barcodearr: any = [];
    let currentDate = new Date().toISOString().slice(0, 10);
    let StockInTransId = 0;
    let showitemfield = ref(false);
    let showadditemfield = ref(true);
    let fullPath = ref();
    let uploadedTableList: any = ref([]);
    let DeletedFileUpload: any = [];
    const StockWOFileUpload = ref([]);
    const ParameterValues = ref({ Id: 0, BranchId: 0, HospitalId: 0 });
    const PrintType = ref({ Type: "S", FormId: 10, ModuleId: 3 });
    const label = ref(t("btn.save"));
    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );
    let showFields = {
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      AvailQty: {
        show: true,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      ExpiryDate: {
        show: true,
        require: true,
      },
      UOM: {
        show: true,
        require: true,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
    };

    let colourCodeList = ref([
      { OrderColor: "red", StatusName: "No Stock" },
      { OrderColor: "blue", StatusName: "Partially Issued" },
      { OrderColor: "green", StatusName: "Issued" },
    ]);

    const createrequestForm = ref({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2023-03-27T12:32:26.939Z",
      ModifiedAt: "2023-03-27T12:32:26.939Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ApproverID: 0,
      TaskID: 0,
      IsApprovalRequired: true,
      ApprovalDate: "2023-03-27T12:32:26.939Z",
      TaskStatus: 0,
      TaskExpiryDate: "2023-03-27T12:32:26.939Z",
      TaskName: "",
      Taskpriority: 0,
      ResponseTimeInHours: 0,
      IsAutoApproval: true,
      IsApproved: 0,
      Id: 0,
      DocType: "",
      RefNo: "",
      DocNo: "",
      DocDate: "2023-03-27T12:32:26.939Z",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      DcNo: "",
      DcDate: "2023-03-27T12:32:26.939Z",
      InvoiceNo: "",
      InvoiceDate: "2023-03-27T12:32:26.939Z",
      InWardNo: "",
      InWardDate: "2023-03-27T12:32:26.939Z",
      Type: "",
      Status: "",
      AuthorizedStatus: false,
      CancelReason: "",
      Cancelled: false,
      RefId: 0,
      Remarks: "",
      SubDetailsAmount: 0,
      TaxAmount: 0,
      DiscountAmount: 0,
      Amount: 0,
      ClosedReason: "",
      Closed: false,
      Subject: "",
      HospitalId: 0,
      BranchId: 0,
      GrnPaymentType: "",
      CrNoteAmt: 0,
      DueAmount: 0,
      PatientId: "2",
      VisitId: 3,
      TempPatientId: 1,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      Channel: 0,
      OrderId: 0,
      RequestId: 0,
      RequestNo: "",
      RequestCreatedBy: 0,
      RequestCreatedBranch: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsDraft: 0,

      TotalTransportCharges: 0.0,
      TotalServiceCharges: 0.0,
      TotalOtherCharges: 0.0,
      NetAmount: 0.0,
      Amount: 0.0,
      TaxAmount: 0.0,
      DiscountAmount: 0.0,

      GRNTransportationCharges: "0.00",
      GRNOtherCharges: "0.00",
      GRNDiscount: "0.00",
      GRNTransportationTax: "0.00",
      GRNFreightCharges: "0.00",
      GRNFreightTax: "0.00",

      SGSTTaxAmount: 0.0,
      CGSTTaxAmount: 0.0,
      IGSTTaxAmount: 0.0,
      RoundOff: "0.00",
      TotalQty: 0,


      IsStoreSupplier: false,
      SOPRId: 0,
      SOPOId: 0,
      SOStoreId: 0,
      SOBranchId: 0,
      SOStoreBranchMapId: 0,
      SupplierId: 0,
    });

    const requestForm = ref({
      requestId: "",
      StockWOTransTMId: 0,
      StockOutTMId: 0,
      fromStoreId: ref(),
      fromStoreName: "",
      toStoreId: ref(),
      toStoreName: "",
      issueId: "",
      issueReturnId: "",
      status: 0,
      type: 0,
      StockInTransId: 0,
      Types: 0,
      fromStoreCode: "",
      toStoreCode: "",
      EntityId: 0,
      EntityOperationId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      Channel: 0,
      OrderId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
    });

    const IssusePopupProps = ref({
      requestId: "",
      fromStoreId: 0,
      fromStoreName: "",
      fromStoreCode: "",
      FromStoreBrMapId: 0,
      toStoreId: 0,
      toStoreName: "",
      toStoreCode: "",
      ToStoreBrMapId: 0,
      issueId: "",
      issueReturnId: "",
      type: 0,
      StockOutTMId: 0,
      StockInTransId: 0,
    });

    const commonItemProps = ref({
      storeId: "",
      type: 1,
      fieldType: 0, //0-for Availability check 1- for IssuedQty check
      tostoreId: "",
      itemType: 3, //item type is for item autocomplete 0-only item label will show 1-item + barcode will show / 3-batch wise (will show barcode for batch and not for others)
      requestType: 0, //1-load item with barcode based on requested item
      IsFilter: 0,
      ToStoreBrMapId: 0,
      UOMFlag: true,
      DirectIssueFlag: true,
    });

    const grossvalues: any = ref({
      grossamount: 0.00,
      totaldiscountamount: 0.00,
      taxamount: 0.00,
      transportcharges: 0.00,
      freightcharges: 0.00,
      servicecharges: 0.00,
      othercharges: 0.00,
      netamount: 0.00,
      totalqty: 0.0,

      sgsttaxamount: 0.00,
      cgsttaxamount: 0.00,
      igsttaxamount: 0.00
    });

    let remarks = ref({
      Remarks: "",
    });

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    let DocNoOpiton: any = ref([]);

    const QueryValue = JSON.parse(route.query.data as string);

    let StoreDetails = ref({
      ToStoreDisable: false,
      grnnodisabled: false,
      FromStoreId: 0,
      FromStoreBranchId: 0,
      FromStoreBranchMapId: 0,
      FromStoreName: "",
      ToStoreId: 0,
      ToStoreBranchId: 0,
      ToStoreBranchMapId: 0,
      ToStoreName: "",
      IsStoreSupplier: false,
      SOPRId: 0,
      SOPOId: 0,
      SOStoreId: 0,
      SOBranchId: 0,
      SOStoreBranchMapId: 0,
      SupplierId: 0,
      SupllierStateId: 0,
      GRNDocType: "7",
      GRNId: 0,
      GRNDocNo: "",
      FromStoreOpiton: [] as any[],
      ToStoreOpiton: [] as any[]
    })

    onMounted(async () => {
      debugger;
      await LoadIsStoreSupplier();
    });

    let hiddenStoreSupplierDetails = ref({
      SupplierId: 0,
      SupllierStateId: 0,
    })

    let StoreSupplierVaidationpopup = ref(false);

    async function LoadIsStoreSupplier() {
      debugger;
      try {
        let result = await SupplierMasterService.getSupplierStoreByStoreId(QueryValue.fromStoreId, QueryValue.BranchId);

        if (result["result"].length > 0 && result["result"][0].SupplierId) {
          hiddenStoreSupplierDetails.value.SupplierId = result["result"][0].SupplierId;
          hiddenStoreSupplierDetails.value.SupllierStateId = result["result"][0].SupllierStateId;
          await LoadToStore();
          getParamsValue();
        }
        else {

          StoreSupplierVaidationpopup.value = true;

          setTimeout(() => {
            setupHistoryManagement(router, 2);
          }, 2000);
          return;
        }
      } catch (error) {
        SaveLoading.value = false;
        console.log("somthing went wrong", error);
      }
    }

    async function LoadGRNDocNo(FromDate, ToDate) {
      debugger;
      try {
        if (FromDate && ToDate) {
          const fromDateFormatted = moment(FromDate).format("YYYY-MM-DD");
          const toDateFormatted = moment(ToDate).format("YYYY-MM-DD");
          const result = await commonService.GetSalesOrderGRNNoByStoreId(
            QueryValue.fromStoreId,
            QueryValue.BranchId,
            HospitalId,
            "",
            fromDateFormatted,
            toDateFormatted
          );

          DocNoOpiton.value = result["result"].map((items) => {
            items.name =
              items.DocNo + " - (" + "Invoice no: " + items.InvoiceNo + ", " + "Net amount: " + items.NetAmount + ", " + "Invoice date: " + items.InvoiceDate + ")";
            items.value = items.Id;
            return items;
          });

        }
      } catch (error) {
        SaveLoading.value = false;
        console.log("somthing went wrong", error);
      }
    }

    async function GRNDocNoOnChange() {
      debugger;

      let ToStoreObj = DocNoOpiton.value.find(
        (item) => item.value === DocNo.value
      );

      if (ToStoreObj) {

        requestForm.value.fromStoreId = ToStoreObj.FromStoreId;
        requestForm.value.fromStoreCode = ToStoreObj.FromStoreCode;
        requestForm.value.fromStoreName = ToStoreObj.FromStoreName;
        requestForm.value.FromStoreBrMapId = ToStoreObj.FromStoreBranchMapId;

        StoreDetails.value.FromStoreId = ToStoreObj.FromStoreId;
        StoreDetails.value.FromStoreBranchId = ToStoreObj.FromStoreBranchId;
        StoreDetails.value.FromStoreBranchMapId = ToStoreObj.FromStoreBranchMapId;
        StoreDetails.value.FromStoreName = ToStoreObj.FromStoreName;

        StoreDetails.value.IsStoreSupplier = ToStoreObj.IsStoreSupplier || false;

        StoreDetails.value.SOPRId = ToStoreObj.SOPRId || 0;
        StoreDetails.value.SOPOId = ToStoreObj.SOPOId || 0;
        StoreDetails.value.SOStoreId = ToStoreObj.SOStoreId || 0;
        StoreDetails.value.SOBranchId = ToStoreObj.SOBranchId || 0;
        StoreDetails.value.SOStoreBranchMapId = ToStoreObj.SOStoreBranchMapId || 0;

        StoreDetails.value.GRNId = ToStoreObj.Id || 0;
        StoreDetails.value.GRNDocNo = ToStoreObj.DocNo || "";

        if (StoreDetails.value.SOPRId) {

          requestForm.value.toStoreId = ToStoreObj.ToStoreId;
          requestForm.value.toStoreCode = ToStoreObj.ToStoreCode;
          requestForm.value.toStoreName = ToStoreObj.ToStoreName;
          requestForm.value.ToStoreBrMapId = ToStoreObj.ToStoreBranchMapId;

          StoreDetails.value.ToStoreId = ToStoreObj.ToStoreId;
          StoreDetails.value.ToStoreBranchId = ToStoreObj.ToStoreBranchId;
          StoreDetails.value.ToStoreBranchMapId = ToStoreObj.ToStoreBranchMapId;
          StoreDetails.value.ToStoreName = ToStoreObj.ToStoreName;

          StoreDetails.value.SupplierId = ToStoreObj.SupplierId || 0;
          StoreDetails.value.SupllierStateId = ToStoreObj.SupllierStateId || 0;

          StoreDetails.value.GRNDocType = "7";
          StoreDetails.value.ToStoreDisable = true;
        }
        else {
          StoreDetails.value.ToStoreDisable = false;
        }

      } else {
        StoreDetails.value.FromStoreId = 0;
        StoreDetails.value.FromStoreBranchId = 0;
        StoreDetails.value.FromStoreBranchMapId = 0;
        StoreDetails.value.FromStoreName = "";

        StoreDetails.value.ToStoreId = 0;
        StoreDetails.value.ToStoreBranchId = 0;
        StoreDetails.value.ToStoreBranchMapId = 0;
        StoreDetails.value.ToStoreName = "";

        StoreDetails.value.IsStoreSupplier = false;
        StoreDetails.value.SOPRId = 0;
        StoreDetails.value.SOPOId = 0;
        StoreDetails.value.SOStoreId = 0;
        StoreDetails.value.SOBranchId = 0;
        StoreDetails.value.SOStoreBranchMapId = 0;
        StoreDetails.value.SupplierId = 0;

        StoreDetails.value.ToStoreDisable = false;
      }

      await GetGRNItemDetails();
    }

    async function GetGRNItemDetails() {
      debugger;
      try {
        loading.value = true;

        items.value = items.value.filter((item) => item.grntype !== 1);

        let result = await commonService.GetStockInDetailsByRefId(
          String(DocNo.value),
          StoreDetails.value.ToStoreId,
          StoreDetails.value.ToStoreBranchMapId
        );

        if (result["result"]) {
          items.value = result["result"].map((item: any) => {
            ItemQtyOnChange(item)
            return item;
          });

          createrequestForm.value.GRNTransportationCharges = result["result"][0]['totaltransportcharges'] || 0.00;
          createrequestForm.value.GRNFreightCharges = result["result"][0]['GRNFreightCharges'] || 0.00;;

          createrequestForm.value.GRNOtherCharges = result["result"][0]['GRNOtherCharges'] || 0.00;
          createrequestForm.value.GRNDiscount = result["result"][0]['GRNDiscount'] || 0.00;

          createrequestForm.value.GRNTransportationTax = result["result"][0]['GRNTransportationTax'] || 0.00;
          createrequestForm.value.GRNFreightTax = result["result"][0]['GRNFreightTax'] || 0.00;

          createrequestForm.value.RoundOff = result["result"][0]['RoundOff'] || 0.00;

          await TransportAmountOnChange();
          await FreightAmountOnChange();

          await OverallOtherChargesOnChange();
          await OverAllDiscountAmountOnChange();
        }

        // if (result["result"]) {
        //   const existingBarcodes = new Set(
        //     items.value.map((item) => item.BarCodeNo)
        //   );
        //   const updatedItems = result["result"]
        //     .filter((item) => !existingBarcodes.has(item.BarCodeNo))
        //     .map((item) => ({ ...item, grntype: 1, RequestedQty: 0, Id: 0 }));

        //   items.value.push(...updatedItems);
        // }
      }
      catch (error) {
        loading.value = false;
        console.error("Error in GetGRNItemDetails: ", error);
      }
      finally {
        loading.value = false;
      }
    }

    async function getParamsValue() {
      debugger;
      const data = route.query.data as string;
      const requestform1 = JSON.parse(data);
      Entitydata.value = requestform1["EntityId"];
      requestForm.value.Types = requestform1["Types"];
      requestForm.value.issueId = requestform1["issueId"] ?? "";
      requestForm.value.issueReturnId = requestform1["issueReturnId"] ?? "";
      requestForm.value.status = requestform1["status"];
      requestForm.value.type = requestform1["type"];

      UOM();

      if (requestform1["type"] == "1" || requestform1["type"] == "2") {
        GetCode();
      }

    }

    let RequestCreatedBy = ref(0);
    let RequestCreatedBranch = ref(0);

    function ShowItems() {
      showitemfield.value = true;
      showadditemfield.value = false;
    }

    let actionReplacement = ref(false);
    let actionDelete = ref(false);
    let objectdata = ref({});

    const itemList = ref([
      {
        items: [
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: actionDelete,
            command: async () => {
              IsItemDelete(objectdata);
            },
          },
        ],
      },
    ]);

    const menu = ref();

    const toggle = (event, data) => {
      debugger;
      if (!data.ReplacementFlag) {
        actionReplacement.value = true;
      } else {
        actionReplacement.value = false;
      }

      actionDelete.value = true;

      objectdata = data;
      menu.value.toggle(event);
    };

    const headers = [
      {
        header: t("storetabdetails.issuecreationtable.Category"),
        field: "ItemCategory1",
        slot: "ItemCategorySlot",
        class: "smallwidth newcolumnfreezeleft1",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.issuecreationtable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",
        slot: "Itemname1",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },
      {
        header: t("storetabdetails.issuecreationtable.Brand/Model/Size"),
        field: "",
        slot: "ModelNumberNameSlot",
        bodyclass: "text_overflow2",
        class: "mediumwidth newcolumnfreezeleft4",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.BatchNo"),
        field: "BatchNo",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.UOM"),
        field: "UOMId",
        slot: "UOMSlot",

        class: "smallwidth",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.ExpDate"),
        field: "ExpiryDate",
        slot: "ExpiryDate",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
        class: "newcolumnfreezeleft5",
      },
      {
        header: t("storetabdetails.issuecreationtable.ToStoreAvlqty"),
        field: "ToStoreStockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.AvlQty"),
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.IssuedQty"),
        field: "IssuedQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.grncreationtable.MRP'),
        field: "",
        slot: "MRPSlot",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.UnitRate'),
        field: "",
        slot: "UnitRateSlot",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth"
      },

      {
        header: t('storetabdetails.grncreationtable.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Discount%'),
        field: "Discount",
        slot: "Discount",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.grncreationtable.Discount'),
        field: "Discountamount",
        bodyclass: "right_td",
        slot: "DiscountAmount",
        fieldDisplay: "false",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Tax%'),
        field: "PurchasePercentage",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Tax'),
        field: "Purchasetaxamount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.SGST%'),
        field: "SGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.SGST'),
        field: "SGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.CGST%'),
        field: "CGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.CGST'),
        field: "CGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.IGST%'),
        field: "IGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.IGST'),
        field: "IGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.ServiceCharges'),
        field: "servicecharges",
        slot: "servicecharges",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.OtherCharges'),
        field: "othercharges",
        slot: "othercharges",
        sortable: false,
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Total'),
        field: "Totalvalue",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.SupplierBarCode'),
        field: "SupplierBarCode",
        slot: "SupplierBarCode",
        sortable: false,
        fieldDisplay: "false",
        class: "smallwidth"
      },
      {
        header: t("storetabdetails.issuecreationtable.IssueQty"),
        field: "ItemQuantity",
        slot: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth columnfreezeright",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    };


    const AddItems = (value) => {
      debugger;
      console.log(value);
      items.value = value;
    };

    let issuereturnCode = "";
    let issueCode = "";

    async function GetCode() {
      debugger;
      try {
        let data = {
          EntityId: Entitydata.value,
          HospitalId: HospitalId,
          BranchId: Number(QueryValue.BranchId) ?? 0,
          StoreId: Number(QueryValue.fromStoreId) ?? 0,
        };

        let result: any = await common.getCodeTemplate(data);
        console.log(result);
        issueCode = result;
        requestForm.value.issueId = issueCode;
      } catch (error) {
        SaveLoading.value = false;
        console.log("somthing went wrong", error);
      }
    }


    const LoadUOM = ref({
      UOMoption: [],
      UOMId: null,
    });

    // Load UOM
    async function UOM() {
      debugger;
      try {
        const dataresponse = await UnitMasterService.getdata();

        console.log(dataresponse);
        debugger;

        LoadUOM.value.UOMoption = dataresponse["result"]
          .filter((x) => x.HospitalId == HospitalId)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    function ShowUOMDropdown(data) {
      debugger;
      data.Editable = true;
      data.UOMoption = LoadUOM.value.UOMoption;
    }

    //Submit Function Validation
    async function SubmitFunc() {
      debugger;
      let StockInCount = items.value.filter(
        (item) => Number(item["StockInHand"]) < Number(item["ItemQuantity"])
      ).length;
      let QtyCount = items.value.filter(
        (item) => Number(item["ItemQuantity"]) == 0
      ).length;
      let IssueQuantityCount = items.value.filter(
        (item) =>
          Number(item["RequestedQty"]) - Number(item["IssuedQuantity"]) <
          Number(item["ItemQuantity"])
      ).length;
      let IssueItemCount = items.value.filter(
        (item) => Number(item["ItemQuantity"]) != 0
      ).length;
      if (items.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Add the Item",
          detail: "Please add an item before proceeding.",
          life: 3000,
        });
        return false;
      } else if (StockInCount > 0) {
        toast.add({
          severity: "warn",
          summary: "Issue Quantity must be less than Available Quantity",
          detail:
            "The issue quantity must be less than the available quantity.",
          life: 3000,
        });
        return false;
      } else if (
        IssueQuantityCount > 0 &&
        Number(requestForm.value.type) == 1
      ) {
        toast.add({
          severity: "warn",
          summary: "Issue Quantity must be less than Requested Quantity",
          detail:
            "The issue quantity must be less than the requested quantity.",
          life: 3000,
        });
        return false;
      } else if (IssueItemCount == 0) {
        toast.add({
          severity: "warn",
          summary: "Issue At Least One Item",
          detail: "Please issue at least one item before proceeding.",
          life: 3000,
        });
        return false;
      } else if (QtyCount > 0) {
        modelQty.value = true;
        return false;
      }
      const CategoryNotMappedCount = items.value.some(
        (item) => item.ToStoreCategoryItem === 1
      );
      if (CategoryNotMappedCount == 0) {
        toast.add({
          severity: "warn",
          summary: "Category Not Mapped",
          detail: "Category Not Mapped To " + requestForm.value.toStoreName,
          life: 3000,
        });
        return false;
      }
      IsSubmit();
    }

    async function IsSubmit() {
      debugger;
      try {
        SaveLoading.value = true;
        modelQty.value = false;

        let QueryStringValue1: any = route.query;
        let QueryStringValue2: any = route.query;
        var FileUploadArray: any = [];
        console.log(QueryStringValue1);
        QueryStringValue1 = QueryStringValue1.param;
        let StockOutResult: any;

        QueryStringValue2 = JSON.parse(QueryStringValue2.data);

        createrequestForm.value.Id = 0;
        createrequestForm.value.DocType = "26";
        createrequestForm.value.RefId = StoreDetails.value.GRNId || 0;
        createrequestForm.value.RefNo = StoreDetails.value.GRNDocNo || "";

        createrequestForm.value.StoreId = StoreDetails.value.FromStoreId;
        createrequestForm.value.FromStore = StoreDetails.value.FromStoreId;
        createrequestForm.value.ToStore = StoreDetails.value.ToStoreId;

        createrequestForm.value.RefNo = requestForm.value.requestId;
        createrequestForm.value.DocNo = requestForm.value.issueId;

        createrequestForm.value.StoreBrMapId = StoreDetails.value.FromStoreBranchMapId;
        createrequestForm.value.FromStoreBrMapId =
          StoreDetails.value.FromStoreBranchMapId;
        createrequestForm.value.ToStoreBrMapId = StoreDetails.value.ToStoreBranchMapId;

        createrequestForm.value.BranchId = StoreDetails.value.FromStoreBranchId;
        createrequestForm.value.FromStoreBranchId =
          StoreDetails.value.FromStoreBranchId;
        createrequestForm.value.ToStoreBranchId =
          StoreDetails.value.ToStoreBranchId;

        createrequestForm.value.IsStoreSupplier = StoreDetails.value.IsStoreSupplier || false;
        createrequestForm.value.SOPRId = StoreDetails.value.SOPRId || 0;
        createrequestForm.value.SOPOId = StoreDetails.value.SOPOId || 0;
        createrequestForm.value.SOStoreId = StoreDetails.value.SOStoreId || 0;
        createrequestForm.value.SOBranchId = StoreDetails.value.SOBranchId || 0;
        createrequestForm.value.SOStoreBranchMapId = StoreDetails.value.SOStoreBranchMapId || 0;

        createrequestForm.value.Remarks = remarks.value.Remarks;
        createrequestForm.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        createrequestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        createrequestForm.value.HospitalId = HospitalId;
        createrequestForm.value.ModifiedBy = UserId;
        createrequestForm.value.CreatedBy = UserId;
        createrequestForm.value.EntityId = Number(Entitydata.value);
        createrequestForm.value.EntityOperationId = OperationId.value;
        createrequestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

        createrequestForm.value.DocDate = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        createrequestForm.value.Channel = requestForm.value.Channel;
        createrequestForm.value.OrderId = requestForm.value.OrderId;

        let result: any;
        let checkstockAvailabilityresult: any;
        let id: any = 0;
        let msg: String = "";
        let HiddenStockOutMasterId: any = 0;
        let StockInMasterId: any = 0;

        items.value = items.value.map((items) => {
          items.StoreId = StoreDetails.value.FromStoreId || 0;
          items.BranchId = StoreDetails.value.FromStoreBranchId || 0;
          items.HospitalId = HospitalId || 0;
          return items;
        });

        debugger;
        checkitem.value = items.value
          .filter(
            (item) => item.ItemQuantity > 0 && item.ToStoreCategoryItem == 1
          )
          .map((items) => {
            let itemCopy = { ...items };
            if (items.ReplacementFlag) {
              itemCopy.Brand = items.ReplacedBrand;
              itemCopy.ModelNumber = items.ReplacedModelNumber;
              itemCopy.Size = items.ReplacedSize;
            }
            return itemCopy;
          });

        checkstockAvailabilityresult = await Itemservice.CheckstockAvailability(
          checkitem.value
        );

        debugger;
        const hasStockStatusOneOrTwo = checkstockAvailabilityresult[
          "result"
        ].some((item) => item.StockStatus === 1 || item.StockStatus === 2);

        const hasStockStatusZeroOrOne = checkstockAvailabilityresult[
          "result"
        ].some((item) => item.StockStatus === 0 || item.StockStatus === 1);

        debugger;

        items.value = items.value.map((item) => {

          let stockItem = checkstockAvailabilityresult["result"].find(
            (s) =>
              s.ItemId === item.ItemId &&
              Number(s.BarCodeNo) === Number(item.BarCodeNo) &&
              s.Brand === item.Brand &&
              s.ModelNumber === item.ModelNumber &&
              s.Size === item.Size
          );

          if (stockItem) {
            return {
              ...item,
              StockStatus: stockItem.StockStatus,
              ItemQuantity:
                stockItem.StockStatus === 1
                  ? stockItem.StockInHand
                  : item.ItemQuantity,
              IssuedQuantity:
                stockItem.StockStatus === 1
                  ? stockItem.StockInHand
                  : stockItem.StockStatus === 0
                    ? 0
                    : item.ItemQuantity,
            };
          }

          return item; // fallback if no match found
        });
        debugger;

        if (hasStockStatusOneOrTwo) {
          if (
            (QueryStringValue2["type"] == 2 || QueryStringValue2["type"] == 3) &&
            QueryStringValue2["StockOutTransTMId"] != 0
          ) {

            createrequestForm.value.EntityId = 3151;
            createrequestForm.value.EntityOperationId = 12086002;

            result = await Service.updateStockOutMasterTM(
              createrequestForm.value
            );
            id = QueryStringValue2["StockOutTransTMId"];
          } else if (
            (QueryStringValue2["type"] == 2 &&
              QueryStringValue2["StockOutTransTMId"] == 0) ||
            QueryStringValue2["type"] == 1 ||
            (QueryStringValue2["type"] == 3 &&
              QueryStringValue2["StockTransId"] != 0)
          ) {

            createrequestForm.value.EntityId = 3151;
            createrequestForm.value.EntityOperationId = 12086001;

            result = await Service.creatStockOutMasterTM(createrequestForm.value);
            id = result["result"];
            HiddenStockOutMasterId = result["result"];
          } else {
            console.log(QueryStringValue2);
          }

          let message = result["ErrorInfo"].ErrorCode;

          if (message == null) {
            debugger;

            for (let i = 0; i < items.value.length; i++) {
              let obj = {};
              let OriginaltItem = ref({
                Brand: 0,
                ModelNumber: 0,
                Size: 0,
              });
              OriginaltItem.value.Brand = items.value[i].Brand;
              OriginaltItem.value.ModelNumber = items.value[i].ModelNumber;
              OriginaltItem.value.Size = items.value[i].Size;
              if (
                items.value[i]["ItemQuantity"] > 0 &&
                items.value[i]["StockStatus"] != 0 &&
                items.value[i].ToStoreCategoryItem == 1
              ) {
                (obj["DocType"] = createrequestForm.value.DocType || 0),
                  (obj["StoreId"] = createrequestForm.value.StoreId || 0),
                  (obj["Id"] = items.value[i]["StockOutDetailId"] || 0),

                  obj["StockWoDetailId"] =
                  items.value[i]["StockDetailsId"] || 0;

                obj["StockInId"] =
                  StoreDetails.value.GRNId || 0;

                obj["StockInDetailId"] =
                  items.value[i]["StockInDetailId"] || 0;

                (obj["ItemId"] = items.value[i]["ItemId"]),
                  (obj["Qty"] = items.value[i]["ItemQuantity"]),
                  (obj["RefId"] = id),

                  (obj["Rate"] = items.value[i]["Rate"]);
                obj["UnitRate"] = items.value[i]["UnitRate"];
                obj["PurchaseTax"] = items.value[i]["PurchasePercentage"];
                obj["PurchaseTaxAmount"] = items.value[i]["Purchasetaxamount"];
                obj["SaleTax"] = items.value[i]["SalesPercentage"];
                (obj["SaleTaxAmount"] = items.value[i]["Salestaxamount"]),


                  (obj["PackSizeId"] = items.value[i]["PackageSizeId"] || 0),
                  (obj["HSNId"] = items.value[i]["HSNId"]),
                  (obj["BarCodeNo"] = Number(items.value[i]["BarCodeNo"] || 0)),
                  (obj["BarCode"] = items.value[i]["BarCode"] || "");
                if (items.value[i]["ExpiryDate"]) {
                  obj["ExpiryDate"] = moment(
                    items.value[i]["ExpiryDate"],
                    "DD-MM-YYYY"
                  ).format("YYYY-MM-DD");
                } else {
                  obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
                }
                if (
                  items.value[i]["ManufactureDate"] &&
                  items.value[i]["ManufactureDate"] != "01-01-0001"
                ) {
                  obj["ManufactureDate"] = moment(
                    items.value[i]["ManufactureDate"],
                    "DD-MM-YYYY"
                  ).format("YYYY-MM-DD");
                } else {
                  obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
                }
                (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                  (obj["ModifiedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["CreatedBy"] = UserId),
                  (obj["ModifiedBy"] = UserId),
                  (obj["UOM"] = items.value[i]["UOM"]),
                  (obj["BatchNo"] = items.value[i]["BatchNo"]),
                  (obj["Brand"] =
                    items.value[i]["Brand"] == null
                      ? 0
                      : items.value[i]["Brand"]),
                  (obj["ModelNumber"] =
                    items.value[i]["ModelNumber"] == null
                      ? 0
                      : items.value[i]["ModelNumber"]),
                  (obj["Size"] =
                    items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);
                (obj["OriginalBrand"] =
                  items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
                  (obj["OriginalModelNumber"] =
                    items.value[i]["ModelNumber"] == null
                      ? 0
                      : items.value[i]["ModelNumber"]),
                  (obj["OriginalSize"] =
                    items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);

                obj["ReplacementFlag"] = items.value[i]["ReplacementFlag"]
                  ? 1
                  : 0;
                (obj["RoomId"] = 0),
                  (obj["RackId"] = 0),
                  (obj["RowId"] = 0),
                  (obj["BoxId"] = 0),
                  (obj["IsApproved"] = 0),
                  (obj["ConsigneeItem"] = items.value[i]["ConsigneeItem"] || 0),
                  (obj["PickStartTime"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["PickEndTime"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["CurrentStockInHand"] =
                    items.value[i]["StockInHand"] || 0),
                  (obj["AssetFlag"] = items.value[i]["Asset"] ? 1 : 0);
                for (let k = 0; k < items.value.length; k++) {
                  const element = items.value[k];
                  if (element["ItemId"] == items.value[i]["ItemId"]) {
                    let barcodoutearry = {};
                    barcodoutearry["BarCode"] = element["BarCode"];
                    Barcodearr.push(barcodoutearry);
                  }
                }
                obj["usedOutBarcode"] = Barcodearr;
                if (obj["ReplacementFlag"] == true) {
                  obj["Brand"] =
                    items.value[i]["ReplacedBrand"] == null
                      ? 0
                      : items.value[i]["ReplacedBrand"];
                  obj["ModelNumber"] =
                    items.value[i]["ReplacedModelNumber"] == null
                      ? 0
                      : items.value[i]["ReplacedModelNumber"];

                  obj["Size"] =
                    items.value[i]["ReplacedSize"] == null
                      ? 0
                      : items.value[i]["ReplacedSize"];

                }
                arr.push(obj);
                Barcodearr = [];
              }
            }
            debugger;
            StockOutResult = await Service.CreateBarcodeStockOut(arr);
            let msgMapping = result["ErrorInfo"].ErrorCode;
            debugger;
            let ConsigneeArr: any = items.value.filter(
              (item: any) => item.ConsigneeItem == 1 && item.ItemQuantity > 0
            );
            if (ConsigneeArr.length > 0) {
              const uniqueSupplierIdsSet = new Set<string>();
              ConsigneeArr.forEach((obj) => {
                uniqueSupplierIdsSet.add(obj.SupplierId);
              });
              const uniqueSupplierIdsArray = Array.from(uniqueSupplierIdsSet);
              for (let i = 0; i < uniqueSupplierIdsArray.length; i++) {
                let itemValue = ConsigneeArr.filter(
                  (item) => item.SupplierId == uniqueSupplierIdsArray[i]
                );
                const TotalAmount = itemValue.reduce(
                  (accumulator, currentValue) => {
                    return accumulator + currentValue.Totalvalue;
                  },
                  0
                );
                let requestItem = ref({
                  DocType: "4",
                  SupplierId: Number(uniqueSupplierIdsArray[i]),
                  CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  BranchId: StoreDetails.value.FromStoreBranchId,
                  HospitalId: HospitalId,
                  CreatedBy: UserId,
                  DocDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                  EntityId: 3044,
                  EntityOperationId: 3044001,
                  StoreId: Number(StoreDetails.value.FromStoreId),
                  FromStore: Number(StoreDetails.value.FromStoreId),
                  ToStore: Number(StoreDetails.value.ToStoreId),
                  RefId: id || 0,
                  IsConsigneeItem: 1,
                  Amount: Number(TotalAmount) || 0,
                  Id: 0,
                  IsServiceLevel: 0,
                  PaymentTermsId: 0,
                  DeliveryTermsId: 0,
                });
                var response = await commonServiceWO.createStockWOTM(
                  requestItem.value
                );
                let id1 = response["result"];
                msgMapping = response["ErrorInfo"].ErrorCode;
                if (msgMapping == null) {
                  let conArr: any = [];
                  for (let j = 0; j < itemValue.length; j++) {
                    let obj = {};
                    (obj["Id"] = 0),
                      (obj["IsConsigneeItem"] = 1),
                      (obj["BarCodeNo"] = itemValue[j]["BarCodeNo"]),
                      (obj["ItemId"] = itemValue[j]["ItemId"]),
                      (obj["Qty"] = itemValue[j]["ItemQuantity"]),
                      (obj["RefId"] = id1),
                      (obj["PackSizeId"] = itemValue[j]["PackSizeId"]),
                      (obj["HSNId"] = itemValue[j]["HSNId"]),
                      (obj["CreatedAt"] = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                      )),
                      (obj["ModifiedAt"] = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                      )),
                      (obj["CreatedBy"] = UserId),
                      (obj["ModifiedBy"] = UserId),
                      (obj["Rate"] = itemValue[j]["Rate"]),
                      (obj["UnitRate"] = itemValue[j]["UnitRate"]),
                      (obj["Description"] = itemValue[j]["Description"]),
                      (obj["Brand"] =
                        itemValue[j]["Brand"] == null
                          ? 0
                          : itemValue[j]["Brand"]),
                      (obj["ModelNumber"] =
                        itemValue[j]["ModelNumber"] == null
                          ? 0
                          : itemValue[j]["ModelNumber"]),
                      (obj["Size"] =
                        itemValue[j]["Size"] == null ? 0 : itemValue[j]["Size"]);
                    (obj["IsApproved"] = 0), conArr.push(obj);
                  }
                  result = await commonServiceWO.createStockWODetails(conArr);
                  msgMapping = result["ErrorInfo"].ErrorCode;
                }
              }
            }
            if (msgMapping == null) {

              createrequestForm.value.DocType = StoreDetails.value.GRNDocType;

              createrequestForm.value.EntityId = StoreDetails.value.GRNDocType == "7" ? 3080 : 3032;
              createrequestForm.value.EntityOperationId = StoreDetails.value.GRNDocType == "7" ? 3080001 : 3032001;

              createrequestForm.value.RefId = id;
              createrequestForm.value.RefNo = "";

              createrequestForm.value.StoreId = StoreDetails.value.ToStoreId;
              createrequestForm.value.StoreBrMapId =
                StoreDetails.value.ToStoreBranchMapId;
              createrequestForm.value.BranchId =
                StoreDetails.value.ToStoreBranchId;

              createrequestForm.value.RequestCreatedBy = RequestCreatedBy.value || 0;
              createrequestForm.value.RequestCreatedBranch =
                StoreDetails.value.ToStoreBranchId;

              createrequestForm.value.IsStoreSupplier = StoreDetails.value.IsStoreSupplier
              createrequestForm.value.SOPRId = StoreDetails.value.SOPRId
              createrequestForm.value.SOPOId = StoreDetails.value.SOPOId
              createrequestForm.value.SOStoreId = StoreDetails.value.SOStoreId || 0;
              createrequestForm.value.SOBranchId = StoreDetails.value.SOBranchId || 0;
              createrequestForm.value.SOStoreBranchMapId = StoreDetails.value.SOStoreBranchMapId || 0;
              createrequestForm.value.SupplierId = StoreDetails.value.SupplierId

              createrequestForm.value.TotalTransportCharges =
                grossvalues.value.transportcharges || 0.00;

              createrequestForm.value.TotalServiceCharges =
                grossvalues.value.servicecharges || 0.00;

              createrequestForm.value.TotalOtherCharges = grossvalues.value.othercharges || 0.00;

              createrequestForm.value.NetAmount = grossvalues.value.netamount || 0.00;

              createrequestForm.value.Amount = grossvalues.value.grossamount || 0.00;

              createrequestForm.value.TotalQty = grossvalues.value.totalqty || 0.00;

              createrequestForm.value.DiscountAmount =
                grossvalues.value.totaldiscountamount || 0.00;

              createrequestForm.value.TaxAmount = grossvalues.value.taxamount || 0;

              createrequestForm.value.SGSTTaxAmount = grossvalues.value.sgsttaxamount || 0.00;
              createrequestForm.value.CGSTTaxAmount = grossvalues.value.cgsttaxamount || 0.00;
              createrequestForm.value.IGSTTaxAmount = grossvalues.value.igsttaxamount || 0.00;

              createrequestForm.value.RoundOff = createrequestForm.value.RoundOff || "0.00";

              if (
                (QueryStringValue2["type"] == 2 &&
                  QueryStringValue2["StockOutTransTMId"] != 0) ||
                (QueryStringValue2["type"] == 3 &&
                  QueryStringValue2["StockOutTransTMId"] != 0 &&
                  QueryStringValue2["StockTransId"] != 0)
              ) {
                createrequestForm.value.Id = StockInTransId;

                createrequestForm.value.EntityId = 3082;
                createrequestForm.value.EntityOperationId = 3082002;

                result = await commonService.updateStockInTM(
                  createrequestForm.value
                );
                id = StockInTransId;
              } else if (
                (QueryStringValue2["type"] == 2 &&
                  QueryStringValue2["StockOutTransTMId"] == 0) ||
                QueryStringValue2["type"] == 1 ||
                (QueryStringValue2["type"] == 3 &&
                  QueryStringValue2["StockTransId"] != 0 &&
                  QueryStringValue2["StockOutTransTMId"] == 0)
              ) {


                result = await commonService.createStockInTM(
                  createrequestForm.value
                );
                id = result["result"];
              }
            }
            debugger;
            let message1 = result["ErrorInfo"].ErrorCode;
            let barcodearry: any = ref([]);
            if (message1 == null) {
              debugger;
              let arr1: any = [];
              debugger;
              for (let i = 0; i < items.value.length; i++) {
                let ItemData
                  = StockOutResult["result"].filter(
                    (item) =>
                      item.ItemId === items.value[i]["ItemId"] &&
                      item.Brand == items.value[i]["Brand"] &&
                      item.ModelNumber == items.value[i]["ModelNumber"] &&
                      item.Size == items.value[i]["Size"] &&
                      item.BatchNo == items.value[i]["BatchNo"]
                  );

                if (
                  items.value[i].Asset == 0 ||
                  (items.value[i].Asset == 1 &&
                    !arr1.some((item) => item.ItemId === items.value[i].ItemId))
                ) {
                  for (let j = 0; j < ItemData.length; j++) {
                    let obj = {};
                    barcodearry.value = [];
                    if (
                      items.value[i]["ItemQuantity"] > 0 &&
                      items.value[i]["StockStatus"] != 0 &&
                      items.value[i].ToStoreCategoryItem == 1
                    ) {
                      (obj["Id"] = items.value[i]["StockInDetailsId"] ?? 0),

                        obj["StockWoDetailId"] =
                        items.value[i]["StockDetailsId"] || 0;

                      (obj["ItemId"] = items.value[i]["ItemId"]),
                        (obj["Qty"] = ItemData[j]["Qty"] || 0.0),
                        (obj["POQty"] = items.value[i]["ItemQuantity"] || 0.0),
                        (obj["RefId"] = id),
                        (obj["PackSizeId"] = items.value[i]["PackSizeId"] || 0),
                        (obj["HSNId"] = items.value[i]["HSNId"] || 0),
                        (obj["UnitMRP"] = items.value[i]["MRP"] || 0),
                        (obj["CreatedAt"] = moment().format(
                          "YYYY-MM-DDTHH:mm:ss.SSSZ"
                        )),
                        (obj["ModifiedAt"] = moment().format(
                          "YYYY-MM-DDTHH:mm:ss.SSSZ"
                        )),
                        (obj["CreatedBy"] = UserId),
                        (obj["ModifiedBy"] = UserId),

                        //   (obj["Rate"] =
                        //     ItemData[j]["Qty"] * ItemData[j]["UnitRate"] || 0);
                        // obj["UnitRate"] = ItemData[j]["UnitRate"] || 0;
                        // obj["PurchaseTax"] =
                        //   items.value[i]["PurchasetaxPercentage"] || 0;
                        // obj["PurchaseTaxAmount"] =
                        //   items.value[i]["Purchasetaxamount"] || 0;
                        // obj["SalesTax"] = items.value[i]["SalestaxPercentage"] || 0;
                        // obj["SalesTaxAmount"] =
                        //   items.value[i]["Salestaxamount"] || 0;
                        // obj["DiscountPer"] = items.value[i]["Discount"] || 0;
                        // obj["DiscountAmount"] =
                        //   items.value[i]["DiscountAmount"] || 0;

                        (obj["Rate"] = items.value[i]["Rate"] || 0);
                      obj["UnitRate"] = items.value[i]["UnitRate"] || 0;
                      obj["PurchaseTax"] = items.value[i]["PurchasePercentage"];
                      obj["PurchaseTaxAmount"] = items.value[i]["Purchasetaxamount"];
                      obj["SaleTax"] = items.value[i]["SalesPercentage"];
                      obj["SaleTaxAmount"] = items.value[i]["Salestaxamount"];

                      (obj["SGSTTax"] = items.value[i]["SGSTTax"]),
                        (obj["SGSTTaxAmount"] = items.value[i]["SGSTTaxAmount"]),
                        (obj["CGSTTax"] = items.value[i]["CGSTTax"]),
                        (obj["CGSTTaxAmount"] = items.value[i]["CGSTTaxAmount"]),
                        (obj["IGSTTax"] = items.value[i]["IGSTTax"]),
                        (obj["IGSTTaxAmount"] = items.value[i]["IGSTTaxAmount"]),

                        obj["DiscountPer"] =
                        items.value[i]["Discount"] == "" ? 0 : items.value[i]["Discount"];
                      obj["DiscountAmount"] = items.value[i]["Discountamount"];

                      obj["TransportCharges"] =
                        items.value[i]["transportcharges"] == ""
                          ? 0
                          : items.value[i]["transportcharges"] || 0;
                      obj["ServiceCharges"] =
                        items.value[i]["servicecharges"] == ""
                          ? 0
                          : items.value[i]["servicecharges"] || 0;
                      obj["OtherCharges"] =
                        items.value[i]["othercharges"] == ""
                          ? 0
                          : items.value[i]["othercharges"] || 0;

                      obj["TotalValue"] = items.value[i]["Totalvalue"];


                      obj["ExpiryDate"] = currentDate;
                      obj["ManufactureDate"] = currentDate;

                      // obj["TransportCharges"] =
                      //   items.value[i]["transportcharges"] || 0;
                      // obj["ServiceCharges"] =
                      //   items.value[i]["servicecharges"] || 0;
                      // obj["OtherCharges"] = items.value[i]["othercharges"] || 0;

                      obj["BatchNo"] = items.value[i]["BatchNo"] || "";
                      obj["TotalValue"] = items.value[i]["Totalvalue"] || 0;
                      obj["RefBarCodeNo"] = ItemData[j]["BarCodeNo"] || 0;
                      obj["RefBarCode"] = ItemData[j]["BarCode"] || "";
                      (obj["SupplierBarCode"] = items.value[i]["SupplierBarCode"]);

                      obj["Channel"] = requestForm.value.Channel || 0;
                      obj["OrderId"] = requestForm.value.OrderId || 0;
                      obj["HospitalId"] = HospitalId || 0;
                      obj["BranchId"] = Number(BranchId) || 0;
                      obj["StoreId"] = Number(commonItemProps.value.storeId) ?? 0;

                      for (let k = 0; k < items.value.length; k++) {
                        const element = items.value[k];
                        if (element["ItemId"] == ItemData[j]["ItemId"]) {
                          barcodearry.value.push(element);
                          obj["usedBarcode"] = barcodearry.value;
                        }
                      }

                      if (
                        ItemData[j]["ExpiryDate"] != "01-01-0001" &&
                        ItemData[j]["ExpiryDate"]
                      ) {
                        obj["ExpiryDate"] = moment(
                          ItemData[j]["ExpiryDate"],
                          "DD-MM-YYYY"
                        ).format("YYYY-MM-DD");
                      } else {
                        obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
                      }
                      if (
                        ItemData[j]["ManufactureDate"] != "01-01-0001" &&
                        ItemData[j]["ManufactureDate"] != "01-01-1900" &&
                        ItemData[j]["ManufactureDate"]
                      ) {
                        obj["ManufactureDate"] = moment(
                          ItemData[j]["ManufactureDate"],
                          "DD-MM-YYYY"
                        ).format("YYYY-MM-DD");
                      } else {
                        obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
                      }
                      (obj["Brand"] =
                        items.value[i]["Brand"] == null
                          ? 0
                          : items.value[i]["Brand"]),
                        (obj["ModelNumber"] =
                          items.value[i]["ModelNumber"] == null
                            ? 0
                            : items.value[i]["ModelNumber"]),
                        (obj["Size"] =
                          items.value[i]["Size"] == null
                            ? 0
                            : items.value[i]["Size"]);

                      (obj["IsApproved"] = 0),
                        (obj["UOM"] = items.value[i]["UOM"]),
                        (obj["AssetFlag"] = items.value[i]["Asset"] ? 1 : 0);
                      if (items.value[i]["ReplacementFlag"] == true) {
                        obj["Brand"] =
                          items.value[i]["ReplacedBrand"] == null
                            ? 0
                            : items.value[i]["ReplacedBrand"];
                        obj["ModelNumber"] =
                          items.value[i]["ReplacedModelNumber"] == null
                            ? 0
                            : items.value[i]["ReplacedModelNumber"];
                        obj["Size"] =
                          items.value[i]["ReplacedSize"] == null
                            ? 0
                            : items.value[i]["ReplacedSize"];
                      }
                      arr1.push(obj);
                    }
                  }
                }
              }

              // Remove duplicates from arr1 based on BarCodeNo
              const uniqueArr1 = arr1.filter(
                (item, index, self) =>
                  item.RefBarCodeNo === undefined ||
                  self.findIndex(
                    (i) => i.RefBarCodeNo !== undefined && i.RefBarCodeNo === item.RefBarCodeNo
                  ) === index
              );

              let result1 = await commonService.createStockInDetails(uniqueArr1);
              if (uploadedTableList.value.length != 0) {
                for (let i = 0; i < uploadedTableList.value.length; i++) {
                  let Fileobj = {};
                  (Fileobj["Id"] = uploadedTableList.value[i].Id),
                    (Fileobj["DocType"] = createrequestForm.value.DocType),
                    (Fileobj["RefId"] = id),
                    (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
                    (Fileobj["CreatedAt"] = moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    )),
                    (Fileobj["CreatedBy"] = UserId),
                    (Fileobj["ModifiedBy"] = 0),
                    (Fileobj["EntityId"] = Number(Entitydata.value)),
                    (Fileobj["IsApproved"] = 0),
                    FileUploadArray.push(Fileobj);
                }
                StockWOFileUpload.value = FileUploadArray;
                let FileUploadResult =
                  await StockInFileUploadServices.insertStockWOFile(
                    StockWOFileUpload.value
                  );
              }
              if (DeletedFileUpload.length > 0) {
                debugger;
                let result = await StockInFileUploadServices.DeleteList(
                  DeletedFileUpload.join(",")
                );
              }

              if (StockWODetailsarr.length != 0) {
                result = await StockWODetailsService.DeletedReasonById(
                  StockWODetailsarr
                );
              }
              let msgMapping1 = result1["ErrorInfo"].ErrorCode;

              if (msgMapping1 == null) {
                if (hasStockStatusZeroOrOne) {
                  alreadyexistpop.value = true;
                  SaveLoading.value = false;
                  afterSave.value = true;
                  PrintCrystalReport(
                    HiddenStockOutMasterId,
                    StoreDetails.value.FromStoreBranchId,
                    HospitalId
                  );
                } else {
                  if (
                    (QueryStringValue2["type"] == 2 ||
                      QueryStringValue2["type"] == 3) &&
                    QueryStringValue2["StockOutTransTMId"] != 0
                  ) {
                    PrintCrystalReport(
                      HiddenStockOutMasterId,
                      StoreDetails.value.FromStoreBranchId,
                      HospitalId
                    );
                    SaveLoading.value = false;
                    updatepop.value = true;
                  } else if (
                    (QueryStringValue2["type"] == 2 &&
                      QueryStringValue2["StockOutTransTMId"] == 0) ||
                    QueryStringValue2["type"] == 1 ||
                    (QueryStringValue2["type"] == 3 &&
                      QueryStringValue2["StockTransId"] != 0)
                  ) {
                    PrintCrystalReport(
                      HiddenStockOutMasterId,
                      StoreDetails.value.FromStoreBranchId,
                      HospitalId
                    );
                    SaveLoading.value = false;
                    successpop.value = true;
                  }
                }
              }
            }
          }
        } else {
          alreadyexistpop.value = true;
          SaveLoading.value = false;
          afterSave.value = true;
        }
      } catch (error) {
        SaveLoading.value = false;
        console.log("somthing went wrong", error);
      }
      finally {
        SaveLoading.value = false;
      }
    }

    let StockWODetailsarr: any = [];
    //Item Delete
    async function IsItemDelete(data) {
      debugger;
      let msg = null,
        idChk = "";

      if (items.value.length > 1) {

        if (commonItemProps.value.itemType == 1) {
          idChk = "BarCodeNo";
        } else {
          idChk = "ItemId";
        }

        if (msg == null) {
          items.value = items.value.filter((item) => {
            if (idChk == "BarCodeNo") {
              return item["" + idChk + ""] != data["" + idChk + ""];
            } else {
              return (
                item["" + idChk + ""] != data["" + idChk + ""] ||
                (data.ModelNumber !== undefined &&
                  item["ModelNumber"] !== data.ModelNumber) ||
                (data.Size !== undefined && item["Size"] !== data.Size) ||
                (data.Brand !== undefined && item["Brand"] !== data.Brand) ||
                (data.BatchNo !== undefined && item["BatchNo"] !== data.BatchNo)
              );
            }
          });
          deletepop.value = true;
        }
      }
      else {
        toast.add({
          severity: "info",
          summary: "Cannot Delete Last Item",
          detail: "You cannot delete the last remaining item.",
          life: 3000,
        });
        return;
      }

      Deletemodel.value = false;
    }

    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
      Editmodel.value = false;
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(router, 2);
    }

    function deleteclosetrigger() {
      deletepop.value = false;
    }

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }

    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Deletemodel.value = true;
    }

    function PrintCrystalReport(Id, BranchId, HospitalId) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
      ParameterValues.value.BranchId = BranchId;
      ParameterValues.value.HospitalId = HospitalId;
    }

    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        items.value = [];
        items.value = value;
      }
    };

    const handleChangedocument = async (event: Event) => {
      debugger;
      debugger;
      let result;
      let files: any = "";
      const input = event.target as HTMLInputElement;
      files = input["files"];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, "TransactionFiles");
          console.log("Uploaded :", result);
          let ResponseValue = result;
          ResponseValue["Id"] = 0;
          fullPath.value = result.uploadPath;
          uploadedTableList.value.push(ResponseValue);
        }
      }
      debugger;
      console.log(uploadedTableList.value);
    };

    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }

    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id);
      uploadedTableList.value = uploadedTableList.value.filter(
        (item) => item.fileName != data.fileName
      );
    };


    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }


    async function LoadFromStore() {
      debugger;
      try {
        let result = await commonservice.StoreDropDownListByUserId(
          UserId,
          HospitalId,
          Admin,
          BranchId
        );

        StoreDetails.value.FromStoreOpiton = result["result"];
      } catch (error) {
        SaveLoading.value = false;
        console.log(error);
      }
    }

    async function LoadToStore() {
      debugger;
      try {
        let result = await commonservice.getStoreByStoreId(
          QueryValue.fromStoreId,
          HospitalId,
          QueryValue.BranchId
        );

        StoreDetails.value.ToStoreOpiton = result["result"].filter((x) => x.StoreTypeId == 1 && x.StoreId != QueryValue.fromStoreId)
          .map((item) => {
            item.name = item.Name;
            item.value = item.StoreBranchMapId;
            return item;
          });

      } catch (error) {
        console.log(error);
      }
    }

    async function ToStoreOnChange() {
      debugger;
      if (StoreDetails.value.ToStoreBranchMapId) {

        let ToStoreObj: any = StoreDetails.value.ToStoreOpiton.find(
          (item) => item.value === StoreDetails.value.ToStoreBranchMapId
        );

        if (ToStoreObj) {

          requestForm.value.toStoreId = ToStoreObj.StoreId;
          requestForm.value.toStoreCode = ToStoreObj.Code;
          requestForm.value.toStoreName = ToStoreObj.Name;
          requestForm.value.ToStoreBrMapId = ToStoreObj.StoreBranchMapId;

          StoreDetails.value.ToStoreId = ToStoreObj.StoreId;
          StoreDetails.value.ToStoreBranchId = ToStoreObj.BranchId;
          StoreDetails.value.ToStoreBranchMapId = ToStoreObj.StoreBranchMapId;
          StoreDetails.value.ToStoreName = ToStoreObj.Name;
        }
        else {
          StoreDetails.value.ToStoreId = 0;
          StoreDetails.value.ToStoreBranchId = 0;
          StoreDetails.value.ToStoreBranchMapId = 0;
          StoreDetails.value.ToStoreName = "";
        }

        await LoadFromStore()

        let FromStoreObj: any = StoreDetails.value.FromStoreOpiton.find(
          (item) => item.StoreBranchMapId === QueryValue.storebranchmapid
        );

        requestForm.value.fromStoreId = FromStoreObj.Id;
        requestForm.value.fromStoreCode = FromStoreObj.Code;
        requestForm.value.fromStoreName = FromStoreObj.Name + " - " + FromStoreObj.CurrentBranchName;
        requestForm.value.FromStoreBrMapId = FromStoreObj.StoreBranchMapId;

        StoreDetails.value.FromStoreId = FromStoreObj.Id;
        StoreDetails.value.FromStoreBranchId = FromStoreObj.BranchId;
        StoreDetails.value.FromStoreBranchMapId = FromStoreObj.StoreBranchMapId;
        StoreDetails.value.FromStoreName = FromStoreObj.Name;


        StoreDetails.value.IsStoreSupplier = FromStoreObj.IsStoreSupplier || false;
        StoreDetails.value.SupplierId = hiddenStoreSupplierDetails.value.SupplierId || 0
        StoreDetails.value.SupllierStateId = hiddenStoreSupplierDetails.value.SupllierStateId || 0

        StoreDetails.value.GRNDocType = "8";

        commonItemProps.value.storeId = String(StoreDetails.value.FromStoreId);
        commonItemProps.value.tostoreId = String(StoreDetails.value.ToStoreId);
        commonItemProps.value.ToStoreBrMapId = Number(
          StoreDetails.value.ToStoreBranchMapId
        );

        StoreDetails.value.grnnodisabled = false;

        if (DocNo.value) {
          GetGRNItemDetails()
        }
      }
    }

    function ClearOnClick() {
      debugger;

      StoreDetails.value.FromStoreId = 0;
      StoreDetails.value.FromStoreBranchId = 0;
      StoreDetails.value.FromStoreBranchMapId = 0;
      StoreDetails.value.FromStoreName = "";

      StoreDetails.value.ToStoreBranchMapId = 0;
      StoreDetails.value.ToStoreId = 0;
      StoreDetails.value.ToStoreBranchId = 0;
      StoreDetails.value.ToStoreName = "";

      requestForm.value.fromStoreId = 0;
      requestForm.value.fromStoreCode = "";
      requestForm.value.fromStoreName = "";
      requestForm.value.FromStoreBrMapId = 0;

      requestForm.value.toStoreId = 0;
      requestForm.value.toStoreCode = "";
      requestForm.value.toStoreName = "";
      requestForm.value.ToStoreBrMapId = 0;

      commonItemProps.value.tostoreId = "0";
      commonItemProps.value.ToStoreBrMapId = 0;

      // FromDate.value = "";
      // ToDate.value = "";

      StoreDetails.value.ToStoreDisable = false;
      StoreDetails.value.grnnodisabled = false;
      StoreDetails.value.SupplierId = 0;

      DocNo.value = "";
      items.value = [];
    }

    function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
      let timeout: ReturnType<typeof setTimeout>;

      return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    const debouncedGRNCalculation = debounce(GRNCalculation, 300);

    watch(items, (newItems, oldItems) => {
      debugger;
      if (items.value.length > 0) {
        debouncedGRNCalculation();
      }
    }, { deep: true });


    async function GRNCalculation() {
      debugger;
      await GRNCalcDetailsClear();

      for (let i = 0; i < items.value.length; i++) {
        grossvalues.value.grossamount += parseFloat(items.value[i]["Rate"] || 0.00);
        grossvalues.value.totaldiscountamount += parseFloat(items.value[i]["Discountamount"] || 0.00);
        grossvalues.value.taxamount += parseFloat(items.value[i]["Purchasetaxamount"]);
        grossvalues.value.servicecharges += parseFloat(items.value[i]["servicecharges"] || 0.00);
        grossvalues.value.othercharges += parseFloat(items.value[i]["othercharges"] || 0.00);
        grossvalues.value.sgsttaxamount += parseFloat(items.value[i]["SGSTTaxAmount"]);
        grossvalues.value.cgsttaxamount += parseFloat(items.value[i]["CGSTTaxAmount"]);
        grossvalues.value.igsttaxamount += parseFloat(items.value[i]["IGSTTaxAmount"]);
        grossvalues.value.totalqty += parseFloat(items.value[i]["ItemQuantity"] || 0);
      }

      grossvalues.value.grossamount = Number(grossvalues.value.grossamount).toFixed(2);

      grossvalues.value.totaldiscountamount = Number(Number(createrequestForm.value.GRNDiscount || 0.00) + Number(grossvalues.value.totaldiscountamount || 0.00)).toFixed(2);

      grossvalues.value.taxamount = Number(grossvalues.value.taxamount).toFixed(2);

      grossvalues.value.servicecharges = Number(grossvalues.value.servicecharges || 0.00).toFixed(2);

      grossvalues.value.othercharges = Number(Number(createrequestForm.value.GRNOtherCharges || 0.00) + Number(grossvalues.value.othercharges || 0.00)).toFixed(2);

      grossvalues.value.sgsttaxamount = Number(grossvalues.value.sgsttaxamount).toFixed(2);
      grossvalues.value.cgsttaxamount = Number(grossvalues.value.cgsttaxamount).toFixed(2);
      grossvalues.value.igsttaxamount = Number(grossvalues.value.igsttaxamount).toFixed(2);

      await GRNSubcalculation(0);

    };

    const GRNSubcalculation = async (value) => {
      debugger;
      grossvalues.value.netamount = ((Number(grossvalues.value.grossamount) - Number(grossvalues.value.totaldiscountamount || 0.00)) + (Number(grossvalues.value.taxamount) + Number(grossvalues.value.transportcharges || 0.00) + Number(grossvalues.value.freightcharges || 0.00) + Number(grossvalues.value.servicecharges || 0.00) + Number(grossvalues.value.othercharges || 0.00) + Number(createrequestForm.value.RoundOff || 0.00))).toFixed(2)

      if (value == 0) {
        CopyTransportationTaxAmount = "0.00";
        CopyFreightTaxAmount = "0.00";
      }
      await TransportTaxOnChange();
      await FreightTaxOnChange();
    }

    function GRNCalcDetailsClear() {
      debugger;
      grossvalues.value.grossamount = 0.00;
      grossvalues.value.totaldiscountamount = 0.00;
      grossvalues.value.taxamount = 0.00;
      grossvalues.value.servicecharges = 0.00;
      grossvalues.value.othercharges = 0.00;
      grossvalues.value.sgsttaxamount = 0.00;
      grossvalues.value.cgsttaxamount = 0.00;
      grossvalues.value.igsttaxamount = 0.00;
      grossvalues.value.netamount = 0.00;
      grossvalues.value.totalqty = 0;
    }

    async function TransportAmountOnChange() {
      debugger;
      grossvalues.value.transportcharges = Number(createrequestForm.value.GRNTransportationCharges || 0.00).toFixed(2)
      await GRNSubcalculation(1);
      TransportTaxOnChange();
    }

    let CopyTransportationTaxAmount = "0.00";
    function TransportTaxOnChange() {
      debugger;
      let transportationTaxAmount = Number((Number(createrequestForm.value.GRNTransportationTax || 0.00) / 100) * Number(createrequestForm.value.GRNTransportationCharges || 0.00)).toFixed(2);
      let freightTaxAmount = Number((Number(createrequestForm.value.GRNFreightTax || 0.00) / 100) * Number(createrequestForm.value.GRNFreightCharges || 0.00)).toFixed(2);

      grossvalues.value.taxamount = Number((Number(grossvalues.value.taxamount || 0.00) - Number(CopyTransportationTaxAmount || 0.00)) + Number(transportationTaxAmount || 0.00)).toFixed(2);

      let sgsttaxamount = 0.00;
      let cgsttaxamount = 0.00;
      let igsttaxamount = 0.00;
      if (items.value.length > 0) {
        for (let i = 0; i < items.value.length; i++) {
          sgsttaxamount += parseFloat(items.value[i]["SGSTTaxAmount"]);
          cgsttaxamount += parseFloat(items.value[i]["CGSTTaxAmount"]);
          igsttaxamount += parseFloat(items.value[i]["IGSTTaxAmount"]);
        }
      }

      if (session.BranchStateId != StoreDetails.value.SupllierStateId) {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(transportationTaxAmount || 0.00)).toFixed(2);
      }
      else {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(0.00)).toFixed(2);
      }

      CopyTransportationTaxAmount = transportationTaxAmount;

      grossvalues.value.netamount = ((Number(grossvalues.value.grossamount) - Number(grossvalues.value.totaldiscountamount || 0.00)) + (Number(grossvalues.value.taxamount) + Number(grossvalues.value.transportcharges || 0.00) + Number(grossvalues.value.freightcharges || 0.00) + Number(grossvalues.value.servicecharges || 0.00) + Number(grossvalues.value.othercharges || 0.00) + Number(createrequestForm.value.RoundOff || 0.00))).toFixed(2)
    }

    async function FreightAmountOnChange() {
      debugger;
      grossvalues.value.freightcharges = Number(createrequestForm.value.GRNFreightCharges || 0.00).toFixed(2)
      await GRNSubcalculation(1);
      FreightTaxOnChange()
    }

    let CopyFreightTaxAmount = "0.00";
    function FreightTaxOnChange() {
      debugger;

      let transportationTaxAmount = Number((Number(createrequestForm.value.GRNTransportationTax || 0.00) / 100) * Number(createrequestForm.value.GRNTransportationCharges || 0.00)).toFixed(2);
      let freightTaxAmount = Number((Number(createrequestForm.value.GRNFreightTax || 0.00) / 100) * Number(createrequestForm.value.GRNFreightCharges || 0.00)).toFixed(2);

      grossvalues.value.taxamount = Number((Number(grossvalues.value.taxamount || 0.00) - Number(CopyFreightTaxAmount || 0.00)) + Number(freightTaxAmount || 0.00)).toFixed(2);

      let sgsttaxamount = 0.00;
      let cgsttaxamount = 0.00;
      let igsttaxamount = 0.00;

      if (items.value.length > 0) {
        for (let i = 0; i < items.value.length; i++) {
          sgsttaxamount += parseFloat(items.value[i]["SGSTTaxAmount"]);
          cgsttaxamount += parseFloat(items.value[i]["CGSTTaxAmount"]);
          igsttaxamount += parseFloat(items.value[i]["IGSTTaxAmount"]);
        }
      }

      if (session.BranchStateId != StoreDetails.value.SupllierStateId) {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(0.00)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(freightTaxAmount || 0.00) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
      }
      else {
        grossvalues.value.sgsttaxamount = Number(Number(sgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.cgsttaxamount = Number(Number(cgsttaxamount || 0.00) + Number(Number(freightTaxAmount || 0.00) / 2) + Number(Number(transportationTaxAmount || 0.00) / 2)).toFixed(2);
        grossvalues.value.igsttaxamount = Number(Number(igsttaxamount || 0.00) + Number(0.00)).toFixed(2);
      }

      CopyFreightTaxAmount = freightTaxAmount;

      grossvalues.value.netamount = ((Number(grossvalues.value.grossamount) - Number(grossvalues.value.totaldiscountamount || 0.00)) + (Number(grossvalues.value.taxamount) + Number(grossvalues.value.transportcharges || 0.00) + Number(grossvalues.value.freightcharges || 0.00) + Number(grossvalues.value.servicecharges || 0.00) + Number(grossvalues.value.othercharges || 0.00) + Number(createrequestForm.value.RoundOff || 0.00))).toFixed(2)
    }

    function OverallOtherChargesOnChange() {
      debugger;

      grossvalues.value.othercharges = 0.00;

      for (let i = 0; i < items.value.length; i++) {
        grossvalues.value.othercharges += parseFloat(items.value[i]["othercharges"]);
      }

      grossvalues.value.othercharges = Number(Number(grossvalues.value.othercharges || 0.00) + Number(createrequestForm.value.GRNOtherCharges || 0.00)).toFixed(2);

      GRNSubcalculation(1);
    }

    function OverAllDiscountAmountOnChange() {
      debugger;
      grossvalues.value.totaldiscountamount = 0.00;

      for (let i = 0; i < items.value.length; i++) {
        grossvalues.value.totaldiscountamount += parseFloat(items.value[i]["Discountamount"]);
      }

      grossvalues.value.totaldiscountamount = Number(Number(grossvalues.value.totaldiscountamount || 0.00) + Number(createrequestForm.value.GRNDiscount || 0.00)).toFixed(2);

      GRNSubcalculation(1);
    }

    function RoundOffOnChange() {
      debugger;

      let roundOffValue = Number(createrequestForm.value.RoundOff) || 0.00;

      // Check if RoundOff is out of the allowed range (-5 to 5)
      if (roundOffValue > 1 || roundOffValue < -1) {
        toast.add({
          severity: "warn",
          summary: "Invalid RoundOff Value",
          detail: "RoundOff should be between ₹-1 to ₹1.",
          life: 3000,
        });

        // Reset RoundOff input if invalid
        createrequestForm.value.RoundOff = "0.00";
        grossvalues.value.netamount = (
          Number(grossvalues.value.grossamount) -
          Number(grossvalues.value.totaldiscountamount || 0.00) +
          Number(grossvalues.value.taxamount) +
          Number(grossvalues.value.transportcharges || 0.00) +
          Number(grossvalues.value.freightcharges || 0.00) +
          Number(grossvalues.value.servicecharges || 0.00) +
          Number(grossvalues.value.othercharges || 0.00)
        ).toFixed(2);
        return; // Stop execution if RoundOff is out of range
      }

      // Calculate net amount including round off (positive adds, negative subtracts)
      let calculatedNetAmount = (
        Number(grossvalues.value.grossamount) -
        Number(grossvalues.value.totaldiscountamount || 0.00) +
        Number(grossvalues.value.taxamount) +
        Number(grossvalues.value.transportcharges || 0.00) +
        Number(grossvalues.value.freightcharges || 0.00) +
        Number(grossvalues.value.servicecharges || 0.00) +
        Number(grossvalues.value.othercharges || 0.00) +
        roundOffValue
      ).toFixed(2);

      grossvalues.value.netamount = calculatedNetAmount;

    }

    // function ItemQtyOnChange(data) {
    //   const stockInHand = Number(data.StockInHand);
    //   const itemQuantity = Number(data.ItemQuantity);
    //   const issuedQuantity = Number(data.IssuedQuantity) || 0;

    //   if (
    //     isNaN(stockInHand) ||
    //     isNaN(itemQuantity) ||
    //     isNaN(issuedQuantity)
    //   ) {
    //     toast.add({
    //       severity: "warn",
    //       summary: "Invalid Quantity",
    //       detail: "Please enter valid numeric values for quantity fields.",
    //       life: 3000,
    //     });
    //     data.ItemQuantity = "";
    //     return;
    //   }

    //   if (Number(data.StockInHand) < data.ItemQuantity) {
    //     toast.add({
    //       severity: "warn",
    //       summary: "Insufficient Stock",
    //       detail: "The entered issue quantity exceeds the available stock. Please adjust the quantity.",
    //       life: 3000,
    //     });

    //     data.ItemQuantity = 0;
    //     return false;
    //   }

    //   return true; // Return true if no issues
    // }

    function ItemQtyOnChange(data) {
      debugger;

      const stockInHand = Number(data.StockInHand);
      const itemQuantity = Number(data.ItemQuantity);
      const issuedQuantity = Number(data.IssuedQuantity) || 0;

      if (
        isNaN(stockInHand) ||
        isNaN(itemQuantity) ||
        isNaN(issuedQuantity)
      ) {
        toast.add({
          severity: "warn",
          summary: "Invalid Quantity",
          detail: "Please enter valid numeric values for quantity fields.",
          life: 3000,
        });
        data.ItemQuantity = "";
        return;
      }

      if (Number(data.StockInHand) < data.ItemQuantity) {
        toast.add({
          severity: "warn",
          summary: "Insufficient Stock",
          detail: "The entered issue quantity exceeds the available stock. Please adjust the quantity.",
          life: 3000,
        });

        data.ItemQuantity = 0;
        return false;
      }

      debugger;
      if (data.PurchaseUnit == data.UOM) {
        data.Rate = Number(data.ItemQuantity * data.ConversionFactor * data.UnitRate).toFixed(2);
      }
      else {
        data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
      }

      let BeforeDiscountRate = data.Rate;

      const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
      data.Discountamount = discountAmount.toFixed(2);

      data.Rate = (data.Rate - data.Discountamount).toFixed(2);

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {
        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Rate = BeforeDiscountRate;

      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)

      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemUnitRateOnChange(data) {
      debugger;
      data.Rate = Number(data.ItemQuantity * data.UnitRate).toFixed(2);
      let BeforeDiscountRate = data.Rate;

      const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
      data.Discountamount = discountAmount.toFixed(2);

      data.Rate = (data.Rate - data.Discountamount).toFixed(2);

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {
        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Rate = BeforeDiscountRate;

      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemDiscountAmountCalculation(data) {
      debugger;

      let BeforeDiscountRate = data.Rate;

      const discountAmount = ((data.Discount || 0.00) / 100) * data.Rate;
      data.Discountamount = discountAmount.toFixed(2);

      data.Rate = (data.Rate - data.Discountamount).toFixed(2);

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {
        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Rate = BeforeDiscountRate;

      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemDiscountPercentageCalculation(data) {
      debugger;
      let BeforeDiscountRate = data.Rate;

      const discountPercentage = ((data.Discountamount || 0.00) / data.Rate) * 100;
      data.Discount = discountPercentage.toFixed(2);

      data.Rate = (data.Rate - data.Discountamount).toFixed(2);

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {
        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Rate = BeforeDiscountRate;

      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemServiceChargesOnChange(data) {
      debugger;
      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function ItemOtherChargesOnChange(data) {
      debugger;
      data.Totalvalue = Number((Number(data.Rate) - Number(data.Discountamount)) + Number(data.Purchasetaxamount) + Number(data.servicecharges || 0.00) + Number(data.othercharges || 0.00)).toFixed(2)
      CopyTransportationTaxAmount = "0.00";
      CopyFreightTaxAmount = "0.00";
    }

    function getExpiryDateStyle(expiryDate) {
      // Return empty style for invalid dates
      if (!expiryDate || expiryDate === "01-01-0001" || expiryDate === "01-01-1900") {
        return {};
      }

      try {
        // Parse the date in DD-MM-YYYY format
        const dateParts = expiryDate.split('-');
        if (dateParts.length !== 3) {
          return {};
        }

        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date
        const year = parseInt(dateParts[2], 10);

        const expiry = new Date(year, month, day);
        const currentDate = new Date();

        // Calculate the difference in milliseconds
        const timeDifference = expiry.getTime() - currentDate.getTime();

        // Convert milliseconds to days
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        // If expiry date is within 90 days, return warning color
        if (daysDifference <= 90 && daysDifference >= 0) {
          return {
            color: "#ff9800", // Orange warning color
            fontWeight: "bold"
          };
        }

        // If already expired, return red color
        if (daysDifference < 0) {
          return {
            color: "red",
            fontWeight: "bold"
          };
        }

        return {}; // Default style for dates beyond 90 days
      } catch (error) {
        console.error('Error parsing expiry date:', error);
        return {};
      }
    }

    function getExpiryMessage(expiryDate) {
      // Return empty message for invalid dates
      if (!expiryDate || expiryDate === "01-01-0001" || expiryDate === "01-01-1900") {
        return "";
      }

      try {
        // Parse the date in DD-MM-YYYY format
        const dateParts = expiryDate.split('-');
        if (dateParts.length !== 3) {
          return "";
        }

        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed in JavaScript Date
        const year = parseInt(dateParts[2], 10);

        const expiry = new Date(year, month, day);
        const currentDate = new Date();

        // Calculate the difference in milliseconds
        const timeDifference = expiry.getTime() - currentDate.getTime();

        // Convert milliseconds to days
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        // If expiry date is within 90 days, show message
        if (daysDifference <= 90 && daysDifference >= 0) {
          return `Expires in ${daysDifference} day${daysDifference === 1 ? '' : 's'}`;
        }

        // If already expired, show expired message
        if (daysDifference < 0) {
          const expiredDays = Math.abs(daysDifference);
          return `Expired ${expiredDays} day${expiredDays === 1 ? '' : 's'} ago`;
        }

        return ""; // No message for dates beyond 90 days
      } catch (error) {
        console.error('Error parsing expiry date:', error);
        return "";
      }
    }

    return {
      Itemschanges,
      SubmitFunc,
      colourCodeList,
      Entitydata,
      List,
      // getstorevalue,
      headers,
      filters,
      showitemfield,
      ShowItems,
      showadditemfield,
      paramValue,
      requestForm,
      AddItems,
      loading,
      SaveLoading,
      items,
      showFields,
      IsSubmit,
      createrequestForm,
      issueCode,
      IsItemDelete,
      issuereturnCode,
      remarks,
      IsItemEdit,
      display,
      displayClass,
      dataItems,
      successpop,
      updatepop,
      closetrigger,
      IsConfirmDel,
      dataEdit,
      Deletemodel,
      deletepop,
      Editmodel,
      IsConfirmEdit,
      deleteclosetrigger,
      getParamsValue,
      itemDatas,
      commonItemProps,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      getExpiryDateStyle,
      getExpiryMessage,
      ShowUOMDropdown,
      modelQty,
      IssusePopupProps,
      handleChangedocument,
      uploadedTableList,
      fileviewer,
      fileuploadDelete,
      label,
      // ObjCamp,
      selectedcontent,
      alreadyexistpop,
      alreadyclosetrigger,
      afterSave,
      DocNo,
      DocNoOpiton,
      GRNDocNoOnChange,
      LoadGRNDocNo,
      FromDate,
      ToDate,

      itemList,
      menu,
      toggle,

      StoreDetails,
      ToStoreOnChange,
      StoreSupplierVaidationpopup,
      ClearOnClick,
      grossvalues,
      TransportTaxOnChange,
      TransportAmountOnChange,
      FreightTaxOnChange,
      FreightAmountOnChange,
      OverallOtherChargesOnChange,
      OverAllDiscountAmountOnChange,
      RoundOffOnChange,
      ItemDiscountPercentageCalculation,
      ItemDiscountAmountCalculation,
      ItemServiceChargesOnChange,
      ItemOtherChargesOnChange,
      ItemUnitRateOnChange,
      ItemQtyOnChange
    };
  },
});
</script>
<style lang="scss">
.campdetailscard {
  border: 1px solid #e1e1e1;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.colourCodeStatusBg {
  background-color: #e9e7e7;
  padding: 10px 20px;
  border-radius: 5px;

  .confirmedicon {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
}

.storesupplierpopupbg {
  background-color: #e3f2fd;
  padding: 10px;
  border-radius: 5px;


  p {
    color: #1976d2;
    font-weight: 500;
  }
}

.expiry-message {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
  font-style: italic;
}
</style>
